// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/insurance-union-rates",
  Detail: "/pyr/insurance-union-rates",
  Create: "/pyr/insurance-union-rates",
  Update: "/pyr/insurance-union-rates",
};
